export default __webpack_public_path__ + "static/media/banner2.f1be3e78.png";